import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swiper from 'swiper';
@Component({
  selector: 'app-feed-image',
  templateUrl: './feed-image.component.html',
  styleUrls: ['./feed-image.component.scss']
})
export class FeedImageComponent implements OnInit, AfterViewInit  {
  swiper: any;
  currentIndex: number = 0;
  hasMultipleMedia: boolean = false;
  mediaItems: { url: string, type: 'image' | 'video' }[] = [];
  
  constructor(private dialogRef: MatDialogRef<FeedImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) { 

    if (Array.isArray(data?.mediaItems)) {
      // this.mediaItems = [{ url: data?.mediaItems, type: this.isImage(data?.mediaItems) ? 'image' : 'video' }];
      this.mediaItems = data.mediaItems;
    } 
    // else {
    //   this.mediaItems = data.mediaItems;
    // }
    this.hasMultipleMedia = this.mediaItems.length > 0 ;
    this.currentIndex = data?.selectedIndex || 0;
    }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.hasMultipleMedia) {
      this.initSwiper();
    }
  }
  initSwiper(): void {
    this.swiper = new Swiper('.swiper-container', {
      loop: false,
      initialSlide: this.currentIndex,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
    this.swiper.update();
  }

  dialogClose(): void{

    this.dialogRef.close()
  
  }
  isImage(mediaUrl: string): boolean {
   return !!(mediaUrl && mediaUrl.match(/\.(jpeg|jpg|png|gif)$/i));
  }
  isVideo(mediaUrl: string): boolean {
    return !!(mediaUrl && mediaUrl.match(/\.(mp4|webm|ogg)$/i));
  }

}
